import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoginPage } from '@/components/auth/LoginPage';

/**
 * /login — acceso único por usuario. El producto no se elige antes de autenticar:
 * `ProductProvider` recupera las suscripciones del tenant y permite cambiar de producto dentro del
 * portal. La persona elegida durante el alta sólo sirve para onboarding/permisos iniciales.
 *
 * Métodos de acceso:
 *     - **Enlace por mail** (magic link, passwordless): se ingresa el email, `requestMagicLink`
 *       manda un enlace de un solo uso (TTL 15m) y mostramos la pantalla "Revisá tu mail".
 *     - **Contraseña**: email + password contra `useAuth().login`.
 *
 *  Más Google / Microsoft SSO. El bloque demo se removió a pedido del diseño.
 */
export const Route = createFileRoute('/_public/login')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: LoginPage,
});
